/**
 * NMS Landing Page Sticky Bar Component
 * Shows a sticky bar when the 4th section starts (compensates for GSAP animations in 3rd section)
 */

if (!window.customElements.get('nms-lp-sticky-bar')) {
  class NMSLPStickyBar extends HTMLElement {
    constructor() {
      super();
      this.targetSectionHeight = 0; // Will store the height of the 4th section
    }

    connectedCallback() {
      // Get the product form ID from attribute
      const formId = this.getAttribute('form');
      if (!formId) {
        console.warn('NMSLPStickyBar: No form attribute provided');
        return;
      }

      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      // Find all sections on the page, excluding header and footer
      const allSections = Array.from(document.querySelectorAll('.shopify-section')).filter(section => {
        // Exclude header and footer sections
        return !section.classList.contains('shopify-section--header') &&
               !section.classList.contains('shopify-section--footer') &&
               !section.closest('.shopify-section-group-header-group') &&
               !section.closest('.shopify-section-group-footer-group');
      });

      if (allSections.length < 4) {
        // If less than 4 sections, show after small scroll
        this.setupScrollFallback();
        return;
      }

      // Get the 4th content section (index 3)
      this.targetSection = allSections[3];

      // Calculate and store the height of the 4th section
      this.targetSectionHeight = this.targetSection.offsetHeight;

      // Setup scroll listener for the 4th section
      this.setupScrollListener();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleScrollFallback);
    }

    setupScrollListener() {
      this.handleScroll = () => {
        if (!this.targetSection) return;

        const rect = this.targetSection.getBoundingClientRect();
        const targetBottom = rect.bottom;

        // Show sticky bar when the 4th section starts (top of section reaches viewport top)
        // We subtract the section height from the bottom position to get the top position
        // This compensates for GSAP animations in the 3rd section
        const targetTop = targetBottom - this.targetSectionHeight;

        // Show when the top of the 4th section reaches the top of viewport
        // targetTop will be 0 when section top is at viewport top
        // targetTop will be negative when we've scrolled past the section top
        if (targetTop <= 0) {
          if (!this.classList.contains('is-visible')) {
            this.classList.add('is-visible');
          }
        } else {
          if (this.classList.contains('is-visible')) {
            this.classList.remove('is-visible');
          }
        }
      };

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    setupScrollFallback() {
      // Fallback: Show after scrolling 300px
      this.handleScrollFallback = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        if (scrollY > 300) {
          this.classList.add('is-visible');
        } else {
          this.classList.remove('is-visible');
        }
      };

      window.addEventListener('scroll', this.handleScrollFallback, { passive: true });
    }
  }

  window.customElements.define('nms-lp-sticky-bar', NMSLPStickyBar);
}
